import React from 'react';
import classNames from 'classnames';
import { Typography } from '@capintel/component-lib/typography';
import { Stack } from '@capintel/component-lib/stack';

type Props = {
  className?: string;
  onClick: (event: React.MouseEvent) => void;
  iconUrl?: string;
  title?: string;
  subtitle?: string;
  selected?: boolean;
  disabled?: boolean;
};

const CardButton = ({ className, onClick, iconUrl, title, subtitle, selected, disabled, ...rest }: Props) => (
  <button className={classNames('card-button', className, { selected, disabled })} type="button" onClick={onClick} disabled={disabled} {...rest}>
    <Stack gap="075" align="center">
      {iconUrl && (
        <div className="icon">
          <img alt="" src={iconUrl} />
        </div>
      )}

      {title && (
        <Typography variant="headerSm" as="h3">
          {title}
        </Typography>
      )}

      {subtitle && (
        <Typography variant="bodyMdRegular" as="p">
          {subtitle}
        </Typography>
      )}
    </Stack>
  </button>
);

export default CardButton;
